<template>
  <v-main>
    <v-alert id="alert" v-model="alert.isAlert" :type="alert.type" closable class="row">{{ alert.message }}</v-alert>
    <v-overlay :model-value="showOverlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-container fluid>
      <h1>ログインアカウント</h1>
      <div>
          ※最大{{ maximumNumberOfAccounts }}アカウント登録が可能です。<br>
          ※マイぺージにおけるメンテナンスのご連絡を差し上げることがあります。
      </div>
    </v-container>
    <v-container v-if="loginUser.billinggroupId" fill-height fluid>
      <v-card name="accounts">
        <v-card-title>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="search"
                name="search"
                :append-inner-icon="mdiMagnify"
                label="絞り込み検索"
                variant="underlined"
                double-line
                hide-details
              ></v-text-field>
            </v-col>
            <v-col v-if="isEditable()" cols="12" sm="6" md="6" class="add-btn-height">
              <!-- 新規登録ボタン -->
              <v-toolbar flat color="transparent">
                <v-btn :color="reachMaximum ? 'grey' : 'primary'" variant="elevated" class="mt-n4" :disabled="reachMaximum" @click="edit()">
                  <v-icon :icon="mdiPlus"></v-icon>
                  新規登録
                </v-btn>
              </v-toolbar>
            </v-col>
          </v-row>
        </v-card-title>

        <!-- ログインアカウント一覧 -->
        <v-data-table :headers="headers" :items="accountList" :search="search" hide-default-footer class="elevation-1" density="compact" :sort-by="sortBy" :items-per-page="-1">
          <template #[`item.mypage_user_email`]="props">
            <div class="restrict-email">{{ props.item.mypage_user_email }}</div>
          </template>

          <template #[`item.role`]="props">
            {{ role[props.item.role_id] }}
          </template>

          <template v-if="isEditable()" #[`item.actions`]="props">
            <div class="td-button-inline">
              <v-btn color="primary" size="small" class="td-icon-left" @click="edit(props.item, props.index)"> 編集 </v-btn>
              <v-btn color="error" size="small" class="td-icon-right" @click="confirmDelete(props.item, props.index)"> 削除 </v-btn>
            </div>
          </template>
          <template #bottom></template>
        </v-data-table>
      </v-card>
    </v-container>
    <!-- 新規登録・編集ダイアログ -->
    <template>
      <v-form ref="form" lazy-validation>
        <v-dialog v-model="dialog" persistent max-width="640px">
          <v-card>
            <v-card-title>
              <div class="text-h5">ログインアカウント <span v-if="isAddNewAccount">新規登録</span><span v-else>変更</span></div>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-if="!isAddNewAccount"
                      v-model="editedItem.mypage_user_id"
                      label="ログインID"
                      variant="underlined"
                      readonly
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="editedItem.mypage_user_email"
                      :rules="[rules.required, rules.email]"
                      maxlength="256"
                      label="メールアドレス"
                      variant="underlined"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-radio-group
                      id="roleId"
                      v-model="editedItem.role_id"
                      :error="isRoleEditError"
                      :error-messages="roleEditErrorMessage"
                      label="権限"
                      :rules="[rules.role_id]"
                      inline
                      @update:model-value="changeRole()"
                    >
                      <v-radio label="manager" :value="1"></v-radio>
                      <v-radio label="user" :value="2"></v-radio>
                      <v-radio label="billing user(請求情報のみ)" :value="3"></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-card-text align="left">
                <v-btn :disabled="pushed" variant="elevated" @click="close()"> キャンセル </v-btn>
              </v-card-text>
              <v-card-text align="right">
                <v-btn color="primary" :disabled="pushed" variant="elevated" @click="execSave()">
                  <span v-if="isAddNewAccount">登録</span>
                  <span v-else>更新</span>
                </v-btn>
              </v-card-text>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-form>
    </template>

    <!-- アカウント削除ダイアログ -->
    <template>
      <v-dialog v-model="dialogDelete" persistent max-width="500px">
        <v-card>
          <v-card-title class="text-h5">削除しますか?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-card-text align="left">
              <v-btn :disabled="pushed" variant="elevated" @click="closeDelete()">キャンセル</v-btn>
            </v-card-text>
            <v-card-text align="right">
              <v-btn color="error" :disabled="pushed" variant="elevated" @click="execDelete()">削除する</v-btn>
            </v-card-text>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

    <!-- アカウント削除NGダイアログ -->
    <template>
      <v-dialog v-model="dialogNotDelete" max-width="500px">
        <v-card>
          <v-card-title class="text-h5 del-dialog">{{ disallowDeleteMessage }}</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-card-text align="right">
              <v-btn variant="elevated" @click="closeNotDelete()">閉じる</v-btn>
            </v-card-text>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </v-main>
</template>

<script>
import Api from '@/constants/api';
import UserRole from '@/constants/userrole';
import { mdiMagnify, mdiPlus } from '@mdi/js';

export default {
  data: () => ({
    role: {
      1: 'manager',
      2: 'user',
      3: 'billing user',
    },
    dialog: false,
    dialogDelete: false,
    dialogNotDelete: false,
    editedIndex: -1,
    editedItem: {
      mypage_user_id: '',
      mypage_user_email: '',
      role_id: -1,
    },
    pushed: false,
    headers: [
      { title: 'ログインID', key: 'mypage_user_id', width: '20%' },
      { title: 'メールアドレス', key: 'mypage_user_email', width: '50%' },
      { title: '権限', key: 'role', sortable: false, filterable: false, width: '20%' },
      { title: '', key: 'actions', sortable: false, filterable: false, width: '10%' },
    ],
    loginUser: {
      mypageUserId: '',
      billinggroupId: '',
      roleId: -1,
    },
    maximumNumberOfAccounts: 15,
    accountList: [],
    search: '',
    rules: {
      required: (value) => !!value || '必須項目です。',
      email: (value) => /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(value) || 'メールアドレスが間違っています。',
      role_id: (value) => value === 1 || value === 2 || value === 3 || 'いずれかを選択してください。',
    },
    sortBy: [{ key: 'mypage_user_id', order: 'asc' }],
    showOverlay: false,
    isRoleEditError: false,
    roleEditErrorMessage: '',
    disallowDeleteMessage: '',
    alert: { isAlert: false, type: 'success', message: '' },
    mdiMagnify,
    mdiPlus,
  }),
  computed: {
    isAddNewAccount() {
      return this.editedIndex === -1 ? true : false;
    },
    reachMaximum() {
      return this.accountList.length >= this.maximumNumberOfAccounts;
    },
  },
  created: async function () {
    this.showOverlay = true;
    try {
      await this.makeUserList();
    } finally {
      this.showOverlay = false;
    }
  },
  methods: {
    makeUserList: async function () {
      const accessToken = this.$cookies.get('access_token');
      console.log('accessToken=' + accessToken);

      let sessionResponse = await this.axios.get(Api.PATH_SESSION);
      console.log(sessionResponse);
      if (sessionResponse.data.status == Api.STATUS_SUCCESS) {
        this.loginUser.mypageUserId = sessionResponse.data.session.mypage_user_id;
        this.loginUser.billinggroupId = sessionResponse.data.session.billinggroup_id;
        this.loginUser.roleId = sessionResponse.data.session.role_id;
      } else {
        this.$cookies.remove('access_token');
        this.$router.push({ name: 'Login' });
        return;
      }

      if (!this.loginUser.billinggroupId) {
        console.log('billinggroupId is invalid.');
        return;
      }

      let response = await this.axios.get(Api.PATH_ACCOUNT_USER_LIST, {
        params: {
          billinggroup_id: this.loginUser.billinggroupId,
        },
      });
      console.log(response);
      if (response.data.status == Api.STATUS_SUCCESS) {
        this.accountList = response.data.mypage_list;
        console.log(this.accountList);
      } else {
        throw 'API_ACCOUNT_USER_LIST failed. status=' + response.data.status;
      }

      if (!this.accountList) {
        console.log('accountList is empty.');
        this.accountList = [];
        return;
      }
    },
    showAlert: function (type, message) {
      this.alert.isAlert = true;
      this.alert.type = type;
      this.alert.message = message;
    },
    edit: function (item, index) {
      this.$refs.form.resetValidation();
      this.isRoleEditError = false;
      this.roleEditErrorMessage = '';
      this.editedIndex = -1;
      this.editedItem = { mypage_user_id: '', mypage_user_email: '', role_id: '' };
      if (item && index > -1) {
        this.editedIndex = index;
        this.editedItem = Object.assign({}, item);
        this.editedItem.mypage_user_id = item.mypage_user_id;
        this.editedItem.mypage_user_email = item.mypage_user_email;
        this.editedItem.role_id = item.role_id;
      }
      this.dialog = true;
    },
    execSave: async function () {
      this.pushed = true;
      const validateResult = await this.$refs.form.validate();
      if (!validateResult.valid) {
        console.log('validate error.');
        this.pushed = false;
        // radioボタンのバリデーションエラーに関して手動で色をつける
        this.isRoleEditError = validateResult.errors.some((error) => error.id === "roleId");
        return;
      }
      try {
        if (this.editedIndex > -1) {
          // 更新
          this.isRoleEditError = false;
          this.roleEditErrorMessage = '';
          if (!this.validateRoleDowngrade()) {
            this.isRoleEditError = true;
            this.roleEditErrorMessage = this.editedItem.mypage_user_id + 'は最後のmanager権限の為、ログインアカウント情報は更新できません。';
          } else if (!this.validateOwnRoleDowngrade()) {
            this.isRoleEditError = true;
            this.roleEditErrorMessage = this.editedItem.mypage_user_id + 'のログインアカウント情報の権限変更はできません。';
          } else {
            await this.updateUser(this.editedItem);
          }
        } else {
          // 新規登録
          await this.createUser(this.editedItem);
        }
      } finally {
        this.pushed = false;
      }
    },
    createUser: async function (user) {
      if (!this.isEditable()) {
        throw 'API_ACCOUNT_CREATE_USER unauthorized.';
      }
      const accessToken = this.$cookies.get('access_token');
      let response = await this.axios.post(Api.PATH_ACCOUNT_CREATE_USER, {
        access_token: accessToken,
        billinggroup_id: this.loginUser.billinggroupId,
        mypage_user_email: user.mypage_user_email,
        role_id: user.role_id,
      });
      console.log(response);
      let alertType = 'success';
      let alertMessage = '';
      if (response.data.status == Api.STATUS_SUCCESS) {
        user.mypage_user_id = response.data.mypage_user_id;
        this.accountList.push(user);
        alertMessage = '登録したメールアドレスにログインIDをメールしました。';
      } else if (response.data.status == Api.STATUS_ACCOUNT_DUPLICATED) {
        alertType = 'warning';
        alertMessage = 'そのメールアドレスはすでに登録済です。';
      } else {
        alertType = 'error';
        alertMessage = 'エラーが発生しました。入力内容を確認して、再度登録してください。';
      }
      this.showAlert(alertType, alertMessage);
      setTimeout(() => window.scrollTo({ top: 0 }), 0);
      this.close();
    },
    updateUser: async function (user) {
      if (!this.isEditable()) {
        throw 'API_ACCOUNT_UPDATE_USER unauthorized.';
      }
      const accessToken = this.$cookies.get('access_token');
      let response = await this.axios.post(Api.PATH_ACCOUNT_UPDATE_USER, {
        access_token: accessToken,
        mypage_user_id: user.mypage_user_id,
        billinggroup_id: this.loginUser.billinggroupId,
        mypage_user_email: user.mypage_user_email,
        role_id: user.role_id,
      });
      console.log(response);
      let alertType = 'success';
      let alertMessage = '';
      if (response.data.status == Api.STATUS_SUCCESS) {
        // リスト上で対象外の行が変更される不具合の対応
        const index = this.accountList.findIndex((u) => u.mypage_user_id === user.mypage_user_id)
        Object.assign(this.accountList[index], user);
        alertMessage = user.mypage_user_id + 'のログインアカウント情報を更新しました。';
      } else if (response.data.status == Api.STATUS_ACCOUNT_DUPLICATED) {
        alertType = 'warning';
        alertMessage = '入力されたEmailアドレスは既に登録済みです。';
      } else {
        alertType = 'warning';
        alertMessage = user.mypage_user_id + 'のログインアカウント情報は更新できません。';
      }
      this.showAlert(alertType, alertMessage);
      setTimeout(() => window.scrollTo({ top: 0 }), 0);
      this.close();
    },
    close: function () {
      this.dialog = false;
    },
    confirmDelete: function (item, index) {
      this.editedIndex = -1;
      this.disallowDeleteMessage = '';
      if (index > -1) {
        this.editedIndex = index;
      }
      this.editedItem = Object.assign({}, item);
      this.editedItem.mypage_user_id = item.mypage_user_id;
      this.editedItem.role_id = item.role_id;
      if (this.editedItem.role_id == UserRole.MANAGER && this.accountList.filter((account) => account.role_id == UserRole.MANAGER).length == 1) {
        this.dialogNotDelete = true;
        this.disallowDeleteMessage = this.editedItem.mypage_user_id + 'は最後のManager権限の為、ログインアカウント情報は削除できません。';
      } else if (this.editedItem.role_id == UserRole.MANAGER && this.editedItem.mypage_user_id === this.loginUser.mypageUserId) {
        this.dialogNotDelete = true;
        this.disallowDeleteMessage = this.editedItem.mypage_user_id + 'のログインアカウント情報は削除できません。';
      } else {
        this.dialogDelete = true;
      }
    },
    execDelete: async function () {
      this.pushed = true;
      try {
        await this.deleteUser(this.editedItem);
      } finally {
        this.pushed = false;
      }
    },
    deleteUser: async function (user) {
      const accessToken = this.$cookies.get('access_token');
      let response = await this.axios.post(Api.PATH_ACCOUNT_DELETE_USER, {
        access_token: accessToken,
        mypage_user_id: user.mypage_user_id,
        billinggroup_id: this.loginUser.billinggroupId,
      });
      console.log(response);
      let alertType = 'success';
      let alertMessage = '';
      if (response.data.status == Api.STATUS_SUCCESS) {
        // リスト上の対象外の行が削除される不具合の対応
        const index = this.accountList.findIndex((u) => u.mypage_user_id === user.mypage_user_id);
        this.accountList.splice(index, 1);
        alertMessage = user.mypage_user_id + 'のログインアカウント情報を削除しました。';
      } else if (response.data.status == Api.STATUS_ACCOUNT_DELETE_RESTRICTED) {
        alertType = 'warning';
        alertMessage = user.mypage_user_id + 'のログインアカウント情報は削除できません。';
      } else {
        alertType = 'error';
        alertMessage = 'ログインアカウント情報の削除に失敗しました。';
      }
      this.showAlert(alertType, alertMessage);
      setTimeout(() => window.scrollTo({ top: 0 }), 0);
      this.closeDelete();
    },
    closeDelete: function () {
      this.dialogDelete = false;
    },
    closeNotDelete: function () {
      this.dialogNotDelete = false;
    },
    isEditable: function () {
      switch (this.loginUser.roleId) {
        case UserRole.ADMIN:
        case UserRole.MANAGER:
          return true;
        default:
          return false;
      }
    },
    validateRoleDowngrade: function () {
      if (
        this.editedItem.role_id !== UserRole.MANAGER &&
        this.accountList.find((account) => account.mypage_user_id === this.editedItem.mypage_user_id).role_id === UserRole.MANAGER &&
        this.accountList.filter((account) => account.role_id == UserRole.MANAGER).length == 1
      ) {
        return false;
      }
      return true;
    },
    validateOwnRoleDowngrade: function () {
      if (
        this.editedItem.role_id !== UserRole.MANAGER &&
        this.editedItem.mypage_user_id === this.loginUser.mypageUserId &&
        this.loginUser.roleId === UserRole.MANAGER
      ) {
        return false;
      }
      return true;
    },
    changeRole: function () {
      if (this.isRoleEditError && this.editedItem.role_id === UserRole.MANAGER) {
        this.isRoleEditError = false;
        this.roleEditErrorMessage = '';
      }
    },
  },
};
</script>

<style scoped>
.container {
  width: 95%;
}
.add-btn-height {
  height: 54px;
}
.error-message {
  color: red;
}
.restrict-email {
  max-width: 450px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.td-icon-left {
  float: left;
}
.td-icon-right {
  float: right;
}
.td-button-inline {
  width: 110px !important;
  justify-content: flex-end;
}
.v-overlay {
  align-items: center;
  justify-content: center;
}
.v-data-table :deep(th),
.v-data-table :deep(.v-data-table-footer) {
  font-size: 12px !important;
}
.v-data-table :deep(td) {
  font-size: 14px !important;
}
.del-dialog {
  white-space: initial;
  text-overflow: initial;
}
</style>
